export default "__VITE_ASSET__BbY6eoBO__"